import { getStore } from "~/app/store/getStore";

export const getBannerAffiliatePartner_toBeRemoved = () => getStore().getState().affiliate.visitedAffiliate;
export const getSavedAffiliatePartner_toBeRemoved = () => getStore().getState().affiliate.savedAffiliate;
export const getSavedSubsidiaryId_toBeRemoved = () => getStore().getState().affiliate.savedSubsidiaryId;
